import { Admission } from '@domain/admission';

export const calculateDDP = (offer: Admission) => {
  return offer?.settings?.italyRegulation?.dirittoPrevendita ?? 0;
};
